import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const generateColors = (count) => {
//   return Array.from({ length: count }, () => {
//     const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
//     return randomColor;
//   });
// };
const generateColors = (count) => {
  const baseColors = [
    "#0E4E9A",
    "#5AB8ED",
    "#A6D3FA",
    "#D2EBFF",
  ];

  const getRandomColor = () => {
    const random = Math.floor(Math.random() * 16777215).toString(16).toUpperCase();
    return `#${random.padStart(6, '0')}`;
  };

  const colors = [...baseColors];

  const remaining = count - baseColors.length;
  for (let i = 0; i < remaining; i++) {
    colors.push(getRandomColor());
  }

  return colors.slice(0, count); // Just in case count < 4
};





const PieChart = ({ chartData }) => {

  // Extracting labels and values dynamically
  const types = Object.keys(chartData?.byProviderType || {});
  const labels = types.map(
    (key) => `${key} ${chartData.byProviderType[key] || 0}`
  );
  const values = Object.values(chartData?.byProviderType || {}).map(
    (val) => Number(val) || 0
  );
  const backgroundColors = generateColors(labels.length);
  const data = {
    labels,
    datasets: [
      {
        label: "Provider Types",
        data: values,
        backgroundColor: backgroundColors,
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "65%",
  };

  // Custom plugin for center text
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const { ctx, data, chartArea: { width, height } } = chart;
      ctx.save();
    
      const total = data.datasets[0].data.reduce((acc, v) => acc + Number(v), 0);
    
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
    
     
      ctx.font = "500 14px Raleway"; 
      ctx.fillText("Total Providers", width / 2, height / 2 - 10);

      ctx.font = "600 16px Raleway"; 
      ctx.fillText(`${total}`, width / 2, height / 2 + 10);
    
      ctx.restore();
    }
  };

  return (
    // <div className="card-body mt-3.5">
    <div className="flex items-start gap-4">
      <div style={{ width: '200px', height: '200px' }}>
        <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
      </div>
      
      <div className="mt-4 text-center">
        {types.map((type, index) => (
          <div key={index} className="flex items-center justify-start mb-2">
            <span
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: backgroundColors[index],
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
              }}
            ></span>
            <div className="flex flex-col text-left">
              <span className="text-[12px] text-gray-600 font-medium">{type}</span>
              <span className="text-[14px] font-semibold text-gray-600">{values[index]}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;
